(function () {
    var tocArticleGroup = {
        $carouselItemTitle: $('.toc-article-group_carousel .toc-article-group_title a'),
        $itemSummary: $('.toc-article-group_text p'),
        init: function () {
            tocArticleGroup.truncateCarouselItemTitle();
            tocArticleGroup.truncateItemSummary();
        },
        truncateCarouselItemTitle: function () {
            if (tocArticleGroup.$carouselItemTitle.length) {
                tocArticleGroup.$carouselItemTitle.truncate({
                    lines: 3,
                });
            }
        },
        truncateItemSummary: function () {
            if (tocArticleGroup.$itemSummary.length) {
                tocArticleGroup.$itemSummary.truncate({
                    lines: 4,
                });
            }
        },
    };
    UX.tocArticleGroup = tocArticleGroup;
})();
